import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { PromotionsResourceService } from './promotions-resource.service';

export const PromotionsListResolver = (route: ActivatedRouteSnapshot) => {
    const resource = inject(PromotionsResourceService);
    return resource.getAll(route.paramMap.get('product'));
};

export const PromotionDetailsResolver = (route: ActivatedRouteSnapshot) => {
    const resource = inject(PromotionsResourceService);
    return resource.getSingle(route.paramMap.get('product'), route.paramMap.get('folderId'));
};
